import { apiClient } from "helpers/api_helper";

export const getAllCountryData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Country/GetAllCountry`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllCountryForSelect = async (params?: URLSearchParams) => {
    try {
        const response = await apiClient.get(`/api/v1/Country/GetCountrySelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};